<div class="modal fade" id="logout" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content ">
            <div class="modal-body logout-message">
                {{'logoutMessage' | translate}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn-cancel" data-dismiss="modal">{{'cancel' | translate}}</button>
                <button type="button" class="btn logout-btn" (click)="logout()">{{'logout' | translate}}</button>
            </div>
        </div>
    </div>
</div>